<template>
  <div>
    <div class="border-b py-2 text-xl font-bold leading-7 text-gray-500 sm:truncate sm:text-xl sm:tracking-tight mb-4">Problems</div>
    <ul role="list" class="divide-y divide-gray-100">
      <li v-for="(problem, idx) in problems" :key="idx" class="flex gap-x-4 py-5">
        <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-200/30 text-red-800 dark:border-gray-700 dark:bg-gray-800 text-xl font-bold dark:text-gray-400">
          {{ problem?.importance || 0 }}
        </div>
        <!--<mdicon name="alert-octagon-outline" size="40" class="text-fuchsia-800/50" />-->
        <!--  <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="comment.imageUrl" alt="" />-->
        <div class="flex-auto">
          <div class="flex items-baseline justify-between gap-x-4">
            <div class="text-lg font-semibold leading-6 text-gray-900">{{ problem?.problem || '' }}</div>
            <div class="flex-none text-sm font-semibold text-gray-600">Importance: {{ problem?.importance || 0 }}</div>
          </div>
          <!--<db-linear-progress class="my-2" :value="comment.id" :max="10" :height="30" color="#fb7185"></db-linear-progress>-->
          <!--<db-linear-progress class="my-2" :value="problem.importance" :max="10" :height="12" :reverse="false" color-mode="uniform"></db-linear-progress>-->
          <equalizer-value class="my-2" :value="problem?.importance || 0" :max="10" :height="12" color="#9f1239"></equalizer-value>
          <div class="mt-1 text-md leading-6 text-gray-600">{{ problem?.explanation || '' }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
  import EqualizerValue from '@/components/Charts/EqualizerValue.vue';

  defineProps({
    problems: {
      type: Array,
      default() {
        return [];
      },
    },
  });
</script>
